import { zeroUserStats } from "@bing/shared";
import { useEffect, type ReactNode } from "react";
import { MatchHistory, PerGameStats, StatTotals } from "../components/GameStats";
import { PageShell } from "../components/PageShell";
import { PromoSlot } from "../components/PromoSlot";
import { fa } from "../i18n/fa";
import { useSession } from "../store/context";

/**
 * History (تاریخچه) — the user's match history + win/loss stats, opened from the
 * lobby drawer. It reads the SAME session-store slices as the Profile screen
 * (`GET /me/stats` + `GET /me/history`) and reuses the shared `StatTotals` /
 * `PerGameStats` / `MatchHistory` presentation, so the two stay consistent.
 */
export function History(): ReactNode {
  const stats = useSession((s) => s.stats) ?? zeroUserStats();
  const loadStats = useSession((s) => s.loadStats);
  const loadHistory = useSession((s) => s.loadHistory);
  const setView = useSession((s) => s.setView);
  const pageReturn = useSession((s) => s.pageReturn);

  // Refresh stats + the first history page when the screen mounts.
  useEffect(() => {
    void loadStats();
    void loadHistory();
  }, [loadStats, loadHistory]);

  return (
    <PageShell title={fa.history.title} icon="history" onBack={() => setView(pageReturn)}>
      <StatTotals stats={stats} />
      <PerGameStats stats={stats} />
      <MatchHistory />
      {/* Empty-state promo slot — renders nothing today (no campaign / flag off). */}
      <PromoSlot slot="EMPTY_STATE" className="mt-md" />
    </PageShell>
  );
}
